export default {
  SET_STATE: 'users/admins/SET_STATE',
  FETCH_ADMINS: 'users/admins/FETCH_ADMINS',
  FETCH_SINGLE_ADMIN: 'users/admins/FETCH_SINGLE_ADMIN',
  UPDATE_ADMIN: 'users/admins/UPDATE_ADMIN:',
  CREATE_ADMIN: 'users/admins/CREATE_ADMIN',
  PERFORM_ACTION_ADMIN: 'users/admins/PERFORM_ACTION_ADMIN',
}
